import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@/components/Button/Button';
import { ButtonVariants } from '@/components/Button/Button.types';
import Modal from '@/components/Modal/Modal';
import { showToast } from '@/components/Toast/Toast';
import { ToastTypes } from '@/components/Toast/Toast.types';
import useConfirmationModal from '@/utils/useConfirmationModal/useConfirmationModal';
import styles from './DeleteConfirmationModal.module.css';
import { DeleteConfirmationModalProps } from './DeleteConfirmationModal.types';
import { useDeleteNavigationCodes } from '@/services/bundles/bundles.service';
import { useParams } from 'react-router-dom';

const DeleteConfirmationModal: FC<DeleteConfirmationModalProps> = ({
  isOpen,
  onClose,
  idToDelete,
  openConfirmationModal,
}) => {
  const { t } = useTranslation();
  const { bundleId } = useParams();
  const { mutate: deleteNavigationCode } = useDeleteNavigationCodes(bundleId!);

  const { setTitle, setHideStatusUpdateText } = useConfirmationModal();
  const handleDeleteSuccess = () => {
    onClose();
    setTitle('Navigation Code deleted successfully');
    setHideStatusUpdateText(true);
    openConfirmationModal();
  };
  const handleDeleteError = (error: unknown) => {
    const { message } = error as { message: string };
    if (message !== 'API Gateway request timed out') {
      showToast({
        id: '',
        toastType: ToastTypes.Error,
        label: 'Error deleting navigation code',
      });
    }
  };

  const handleDelete = () => {
    deleteNavigationCode({ id: idToDelete }, { onSuccess: handleDeleteSuccess, onError: handleDeleteError });
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      showTitleDivider
      headerContent={t('common.bundle.deleteConfirmTitle')}
      footerContent={
        <div className={styles.modalButtons}>
          <Button variant={ButtonVariants.Secondary} onClick={onClose} type="button">
            {t('common.cancel')}
          </Button>
          <Button onClick={handleDelete} type="button">
            {t('common.delete')}
          </Button>
        </div>
      }
    />
  );
};

export default DeleteConfirmationModal;
